import { type TChainId } from "@packages/utils/types";
import { accessTokenStore } from "../../../stores";
import { get } from "svelte/store";

export const requestPromoLoyaltyPoints = async ({
  apiUrl,
  eventId,
  contractAddress,
  chainType,
  evmChainId,
}: {
  apiUrl: string;
  eventId: number;
  contractAddress: string;
  chainType: "sui" | "evm";
  evmChainId?: TChainId;
}) => {
  const result = await fetch(`${apiUrl}/promo/loyalty/request-points`, {
    method: "post",
    body: JSON.stringify({
      event_id: eventId,
      contract_address: contractAddress,
      chain_type: chainType,
      ...(chainType === "evm" && evmChainId
        ? { evm_chain_id: +evmChainId }
        : {}),
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${get(accessTokenStore)}`,
    },
  });

  const json = await result.json();
  if (!result.ok) throw new Error(`Points request failed. ${json.message}`);

  return json;
};
